import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import Api from '../../../utils/api';
import Toaster from '../../Toaster/Index';
import { LeftPanel } from '../../Wrappers';
import { sendAmplitudeEvents, updatePluginList } from '../../../utils/helper';
import { EventNames } from '../../../utils/events';
import {
    Button,
    FormControl,
    Link,
    Text,
    TextInput,
} from '@primer/react';
import { LTButton, LTFormControl, LTSelect, LTText } from '@lambdatestincprivate/lt-components';
import LTTextInput from '@lambdatestincprivate/lt-components/lib/components/LTInputBox';

const docLink = `${process.env.REACT_APP_DOC_URL}/assembla-integration/`;

export default function Assembla() {
    const sideBarObject: any = useSelector(
        (state: RootState) => state.config.sideBarObject
    );
    const [isLoading, setIsLoading] = useState(false);
    const [apikey, setApiKey] = useState('');
    const [apisecret, setApiSecret] = useState('');
    const [host, setHost] = useState('');
    const [hostedURL, sethostedURL] = useState('');
    const [errors, setErrors] = useState({});

    const hosts = {
        'US': 'us',
        'EU': 'eu',
        'INDIA':'in'
    }

    const install = async (e: React.ChangeEvent<any>) => {
        e.preventDefault();
        setIsLoading(true);
        setErrors({});
        sendAmplitudeEvents(EventNames.INT_CLICK_INSTALL, {
            category: sideBarObject.category,
            plugin_name: sideBarObject.name,
        });
        try {
            const res = await Api.installApi.apiInstall(sideBarObject.code, {
                "API_KEY":apikey,
                "API_SECRET":apisecret,
                "HOST":host,
                "HOSTED_URL":hostedURL
            });
            if (res.message) {
                Toaster.success(res.message);
            }
            await updatePluginList();
            setIsLoading(false);
        } catch (err: any) {
            setIsLoading(false);
            if (err.response.data.errors) {
                setErrors(err.response.data.errors);
            } else {
                Toaster.error(err.response.data.message);
            }
        }
    };
    
    return (
        <LeftPanel>
            <form
                action=''
                className='flex flex-col space-y-4'
                id='form1'
                onSubmit={install}
            >
                <LTFormControl
                    label='API Key'
                    labelStyle={{
                        fontSize: 12,
                    }}
                    formStyles={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                    }}
                >
                    <LTTextInput
                        inputOnly={true}
                        type='password'
                        id='apikey'
                        aria-label='Apikey'
                        width={'100%'}
                        contrast
                        placeholder=''
                        onChange={(value :any) => setApiKey(value)}
                        trailingAction={() =>setApiKey("")}
                        value={apikey}
                        required
                    />
                    {(errors as any).apikey && (
                        <small className='w-full h-2.5 text-[10px] text-red-600'>
                            {(errors as any).apikey && (errors as any).apikey[0]}
                        </small>
                    )}
                </LTFormControl>
                <LTFormControl
                    label='API Secret'
                    labelStyle={{
                        fontSize: 12,
                    }}
                    formStyles={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                    }}
                >
                    <LTTextInput
                        inputOnly={true}
                        type='password'
                        id='apisecrey'
                        aria-label='Apisecret'
                        width={'100%'}
                        contrast
                        placeholder=''
                        onChange={(value :any) => setApiSecret(value)}
                        trailingAction={() =>setApiSecret("")}
                        value={apisecret}
                        required
                    />
                    {(errors as any).apikey && (
                        <small className='w-full h-2.5 text-[10px] text-red-600'>
                            {(errors as any).apisecret && (errors as any).apisecret[0]}
                        </small>
                    )}
                </LTFormControl>

                <LTFormControl
                    label='Assembla Hosted URL'
                    labelStyle={{
                        fontSize: 12,
                    }}
                    formStyles={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                    }}
                >
                    <LTTextInput
                        inputOnly={true}
                        type='text'
                        id='hostedurl'
                        aria-label='HostedUrl'
                        width={'100%'}
                        contrast
                        placeholder=' e.g https://lambdatest.assembla.com'
                        onChange={(value :any) => sethostedURL(value)}
                        trailingAction={() =>sethostedURL("")}
                        value={hostedURL}
                        required
                    />
                </LTFormControl>

                <LTFormControl
                    label='Select your Assembla Region'
                    labelStyle={{
                        fontSize: 12,
                    }}
                    formStyles={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                    }}
                >
                    <LTSelect
                        options={Object.entries(hosts).map(([key, value]) => ({
                            name: key,
                            value: value,
                        }))}
                        onChange={(values: any) => {
                            setHost(values[0].value);
                        }}
                        customButtonText={host ? hosts[host as keyof typeof hosts] : 'Select Region'}
                        buttonStyle={{
                            width: '100%',
                            maxWidth: '100%',
                            '[data-component="buttonContent"]': {
                                justifyContent: 'start',
                            },
                        }}
                        leadingText=""
                    />
                </LTFormControl>   
                <LTButton
                    variant={LTButton.Variant.PRIMARY}
                    disabled={isLoading}
                    onClick={install}
                    className='self-start'
                >
                    Install
                </LTButton>
            </form>
            <div className='grid inline-block min-[686px]:absolute min-[686px]:bottom-0 max-[685px]:mt-[16px] mb-[16px]'>
                <LTText color={'muted'}
                style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    lineHeight: "16px",
                    color: '#666666'
                  }}
                >Know how to generate</LTText>
                <Link
					className='focus-black'
                    href={docLink}
                    target='_blank'
                    rel='noreferrer'
                >
                    API Key
                </Link>
            </div>
        </LeftPanel>
    );
}
